"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/ImagePodsComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ImageItemPodComponent = /** @class */ (function (_super) {
    __extends(ImageItemPodComponent, _super);
    function ImageItemPodComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageItemPodComponent.prototype.render = function () {
        var hasUrl = this.props.LinkUrl;
        return (react_1.default.createElement("div", { className: "col-sm-12 col-md-6 col-lg-4 d-flex align-items-stretch pb-20 podcontainer" },
            react_1.default.createElement("article", { className: "pod image-pods card card-image matchHeightClass", style: { backgroundImage: "url(" + this.props.ImageUrl + ")" } },
                react_1.default.createElement("div", { className: "card-body" },
                    react_1.default.createElement("h2", { className: "card-title" }, this.props.Title),
                    react_1.default.createElement("div", { className: "card-text", dangerouslySetInnerHTML: { __html: this.props.Content } })),
                react_1.default.createElement("div", { className: "card-footer" }, (hasUrl !== null && hasUrl !== '') ? (react_1.default.createElement("a", { href: this.props.LinkUrl, className: "pods-link" },
                    this.props.LinkTitle,
                    " ",
                    react_1.default.createElement("span", { className: "pods-link-arrow" }, "\u27F6"))) : ""))));
    };
    return ImageItemPodComponent;
}(react_1.Component));
exports.default = ImageItemPodComponent;
